import GradingCreate from "@/controllers/grading/grading-create.js";
import axios from "axios";
import store from "@/store";
export default {
    extends: GradingCreate,

    methods: {
        ...GradingCreate.methods,
        getClass(academic_year) {
            axios.get(`class/classListByAcdYearId/${academic_year}`, {
                params: {
                    campus_id: store.state.user.campus_id,
                },
            })
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class',
                        'subjects': [],
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },
    }
}
